<script lang="ts">
	import { HTMLText } from '@atoms';
	import { TextStyle } from '@atoms/text/TextStyle';
	import type { TextBlock } from './TextBlockQuery';
	import { getContext } from 'svelte';

	const { data }: { data: TextBlock } = $props();

	// default || fullbleed
	const layout: string = getContext('page-layout') ?? 'default';
</script>

<div class={'outer-container ' + layout}>
	<div class="container">
		<HTMLText text={data.text} style={TextStyle.Medium} />
	</div>
</div>

<style lang="scss">
	.outer-container {
		@include blockPaddingSmall;
	}

	.default {
		width: 100%;

		@include md {
			width: cols(7, 5);
		}
	}

	.fullbleed-center {
		@include layoutBlockGrid;

		.container {
			grid-column: 1 / -1;
			@include md {
				grid-column: 4 / span 5;
			}
		}
	}

	.fullbleed {
		@include layoutBlockGrid;

		.container {
			grid-column: 1 / -1;
			@include md {
				grid-column: 6 / span 5;
			}
		}
	}
</style>
